module.exports = "../images/hunting-activities-ear-falls-1.jpg?v=2df171f";